module.exports = __webpack_public_path__ + "img/de38f9225aca642d2ab4cb2090bde2c6.svg";